import script from "./afterSale.vue?vue&type=script&setup=true&lang=js"
export * from "./afterSale.vue?vue&type=script&setup=true&lang=js"

import "./afterSale.vue?vue&type=style&index=0&id=1b449432&lang=less"

const __exports__ = script;

export default __exports__